/* global fbq */
import React, { useEffect, useState, useCallback, useRef, useMemo, useLayoutEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../HeaderNew/component";
import API2 from "../../api/indexv2";
import { GET_CATEGORIES } from "../../api/apiList";
import { debounce } from "lodash";
import Loader from "../../components/common/loader";
import { ToastContainer } from "react-toastify";
import Login from "../Login/component";
import EmptyPage from "../EmptyPage/component";
import {
  fetchSellersCatalog,
  updateCartItem,
} from "../../slices/catalogSlice";
import Breadcrumb from "../../components/common/breadcrumb";
import PageHeader from "./page-header/index";
import StoresCategorySlider from "./stores-category-slider/index";
import FilterSection from "./filter-section/index";
import ProductCard from "../../components/common/product-card";
import {
  errorCodeMessages,
  isStoreOpen,
} from "../../components/common/utils";
import "./styles.scss";
import { notify, handleAddToCart } from "../../components/common/utils";
import StoretimingModal from "../../components/common/StoreTimingModal";
import Pagination from "react-bootstrap/Pagination";
import NoProductFound from "../../images/v2-images/no-product-found.svg";
import NxtTwoBtn from "../../images/home/next-two-btn.svg";
import NxtOneBtn from "../../images/home/next-one-btn.svg";
import axios from "axios";
import { getSingleSellerDetails } from "../../api/ApiService";
import Footer from "../../components/common/Footer";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-creative';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCreative } from 'swiper/modules';
import All from "../../images/All-catagory.png";
import searchedProducts from "../../images/Ellipse 3674.png";
import ManageAddress from "../ManageAddress/component";
import { Modal } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import { ondcSelect } from "../../slices/ondcPreorderSlice";
import MobileAddCart from "../../components/common/mobile-add-cart/index";

let cancelToken;
const SellerComponent = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const catalogues = useSelector((s) => s.catalog.catalogues);
  const catalogueStatus = useSelector((s) => s.catalog.catalogueStatus);
  const catalogueCount = useSelector((s) => s.catalog.catalogueCount);
  const cartItems = useSelector((s) => s.catalog.cartItems);
  const [catalogDataTemp, setCatalogDataTemp] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(-1);
  const [scrollLoading, setScrollLoading] = useState(false);
  const [sellerDetails, setSellerDetails] = useState({});
  const [activeCatalogsCategories, setActiveCatalogsCategories] = useState([]);
  const [isHeaderHide, setIsHeaderHide] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  const [selectedSubcategory, setSelectedSubcategory] = useState(
    searchParams.get("category") || "All"
  );
  const [storeTiming, setStoreTiming] = useState(false);
  const getQueryParams = (queryString) => {
    return new URLSearchParams(queryString);
  };
  const queryParams = getQueryParams(location.search);
  const slug = queryParams.get("pid");
  const search = queryParams.get("search");
  const encodedValue = encodeURIComponent(slug);
  localStorage.setItem("slug", `/seller?pid=${encodedValue}`);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const footerRef = useRef(null);
  const catalogsRef = useRef(null);
  const [addressModal, setAddressModal] = useState(false);
  const token = localStorage.getItem("token");
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const [shippingAddress, setShippingAddress] = useState(defaultAddress?.address);
  const [zipcode, setZipcode] = useState("");
  const [selectLoadingId, setSelectLoadingId] = useState("");
  const [selectLoading, setSelectLoading] = useState(false);
  const [cartError, setCartError] = useState("");
  const [scrollTo, setScrollTo] = useState("");
  const limit = 120;
  const pageCount = Math.ceil(catalogueCount / limit)
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, catalogueCount);

  useEffect(() => {
    setCatalogDataTemp([])
    getSeller(slug);
  }, [slug]);

  const getSeller = async (sellerId) => {
    const body = {
      userId: sellerId,
    };
    const data = await getSingleSellerDetails(body);
    if (data?.success) {
      setSellerDetails(data?.sellerData);
      setActiveCatalogsCategories(data?.activeCategories)
      setIsOpen(isStoreOpen(data?.sellerData));
      const seller_data = { sellerDetails: data?.sellerData, category: searchParams.get("category") }
    }
  };

  useEffect(() => {
    catalogs(false);
  }, [cartItems]);

  useEffect(() => {
    getCategoriesData()
  }, [activeCatalogsCategories]);

  const getCategoriesData = async () => {
    try {
      const response = await API2.post(GET_CATEGORIES);
      if (response.data?.data?.length) {
        const selectedCategory = response?.data?.data
        const groceryCategories = selectedCategory.find(item => item.title === "Grocery")
        const filteredCategories = groceryCategories?.subCategories?.filter(
          (cat) =>
            activeCatalogsCategories.includes(cat.title)
        );
        setCategoriesData(filteredCategories);
      }
    } catch (error) {
      console.log("HOME : ERROR CATEGORIES ", error);
    }
  };

  useEffect(() => {
    if (searchParams.get("category") && !isSearchActive) {
      const categoryParam = searchParams.get("category");
      setSelectedSubcategory(categoryParam);
      setCatalogDataTemp([]);
      fetchCatalogData({
        userId: slug,
        subCategoryId: categoryParam,
        page: page,
        sortValue: sort,
        ...((searchText || search) && selectedSubcategory === "Searched Products" && { search: searchText || search })
      });
    }
  }, [searchParams]);

  useEffect(() => {
    setCatalogDataTemp([]);
    if (search) {
      setSearchText(search)
      setSelectedSubcategory("Searched Products")
    }
    else {
      if (!selectedSubcategory) {
        setSelectedSubcategory("All")
      }
    }
    const categoryParam = searchParams.get("category") || selectedSubcategory;
    if (
      categoriesData?.length === 0 &&
      sellerDetails &&
      Object.keys(sellerDetails).length > 0
    ) {
      setIsOpen(isStoreOpen(sellerDetails));
      getCategoriesData();
    }
    fetchCatalogData({
      userId: slug,
      subCategoryId: categoryParam,
      page: 1,
      sortValue: sort,
      ...(search && { search: search }),
    });
  }, [sellerDetails]);

  useEffect(() => {
    catalogs(true);
  }, [catalogues]);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (!footerRef.current) return;
  //     const footerTop = footerRef.current.getBoundingClientRect().top;
  //     const windowHeight = window.innerHeight;
  //     if (footerTop <= windowHeight + 100) {
  //       const pageCount = Math.ceil(catalogueCount / 20);
  //       if (page < pageCount && catalogueStatus !== "loading") {
  //         setScrollLoading(true)
  //         fetchNextPage();
  //       }
  //     }
  //   };
  //   const debouncedHandleScroll = debounce(handleScroll, 200);
  //   window.addEventListener("scroll", debouncedHandleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", debouncedHandleScroll);
  //   };
  // }, [page, catalogueStatus, catalogueCount]);

  useLayoutEffect(() => {
    if (scrollTo === 'catalogSection') {
      const scrollToSection = () => {
        if (catalogsRef.current) {
          const observer = new MutationObserver(() => {
            if (catalogsRef.current) {
              catalogsRef.current.scrollIntoView({ behavior: 'smooth' });
              const top = catalogsRef.current.getBoundingClientRect().top + window.scrollY - 80;
              window.scrollTo({ top, behavior: 'smooth' });
              observer.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          return () => observer.disconnect();
        } else {
          requestAnimationFrame(scrollToSection);
        }
      };
      scrollToSection();
      setScrollTo("")
    }
  }, [scrollTo]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsHeaderHide(true);
      } else {
        setIsHeaderHide(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchNextPage = (currPage) => {
    setScrollTo("catalogSection")
    if (page === currPage) {
      return
    }
    fetchCatalogData({
      userId: slug,
      subCategoryId: selectedSubcategory,
      page: currPage,
      sortValue: sort,
      ...(searchText && selectedSubcategory === "Searched Products" && { search: searchText })
    });
    setPage(currPage);
    setScrollLoading(false)
  };


  const updatedCategories = useMemo(() => {
    const list = [];
    if (searchText.trim() !== "") {
      list.push({ title: "Searched Products", imgUrl: searchedProducts });
    }
    list.push({ title: "All", imgUrl: All });
    return [...list, ...categoriesData];
  })

  const handleSortChange = (value) => {
    let sorting;
    if (value === "PriceLowToHigh") {
      setSort(0)
      sorting = 0
    } else if (value === "PriceHighToLow") {
      setSort(1)
      sorting = 1
    } else {
      setSort(-1)
      sorting = -1
    }
    setCatalogDataTemp([]);
    setPage(1)
    fetchCatalogData({
      userId: slug,
      subCategoryId: selectedSubcategory,
      page: 1,
      sortValue: sorting,
      ...(searchText && { search: searchText })
    });
  };

  const handleSearchInput = (e) => {
    optimizedUserFn(e)
    if (e.target.value) {
      setIsSearchActive(true)
      setSearchText(e.target.value);
      setSelectedSubcategory("Searched Products")
    }
    else {
      setIsSearchActive(false)
      setSearchText("")
      setSelectedSubcategory("All")
    }
  }

  const dispatchOndcSelect = (updatedCartItems, productId, cb = () => { }) => {
    const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
    setSelectLoading(true);
    setSelectLoadingId(productId)
    if (!token) {
      setModalIsOpen(true);
      setSelectLoading(false);
      return;
    }
    if (!defaultAddress?.address?.address_line2) {
      setAddressModal(true);
      setSelectLoading(false);
      return;
    }
    setCartError("");
    const user = JSON.parse(localStorage.getItem("user"));
    const select_transaction_id = JSON.parse(
      localStorage.getItem("transaction_id")
    );
    const items = updatedCartItems?.map((item) => ({
      id: item.catalogData._id,
      quantity: item.quantity,
    }));
    const transaction_id = select_transaction_id
      ? select_transaction_id
      : uuidv4();
    dispatch(
      ondcSelect({
        userAddress: defaultAddress?.address,
        items,
        userId: user?._id,
        transactionId: transaction_id,
        landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
      })
    ).then((response) => {
      localStorage.setItem("transaction_id", JSON.stringify(transaction_id));
      setSelectLoading(false);
      setSelectLoadingId("");
      if (response?.payload?.success && response?.payload?.data && !response?.payload?.data?.error) {
        cb(true)
      }
      else if (response?.payload?.data?.error?.message?.length > 0) {
        cb(false)
        try {
          const errorData = JSON.parse(response?.payload?.data?.error?.message)
          const errorItem = errorData?.find((item) => item?.item_id === productId);
          const errorCode = errorItem?.error;
          let errorMessage = errorCode ? errorCodeMessages(errorCode) || "" : null;
          setCartError(errorMessage);
          if (typeof errorMessage !== "string") {
            errorMessage = "Uh-oh! Seller facing a technical issue"
          }
          notify("error", errorMessage || "Uh-oh! Seller facing a technical issue")
        } catch (e) {
          setCartError(response?.payload?.data?.error?.message);
          notify("error", response?.payload?.data?.error?.message)
          return
        }
        const errMsg = response?.payload?.data?.error?.message ? response?.payload?.data?.error?.message : response?.payload?.message;
        const error = errorCodeMessages(response?.payload?.data?.error?.code, errMsg);
        if (!response?.payload?.data?.error?.code) {
          const err_with_id = `${errMsg}`;
          setCartError(err_with_id);
          notify("error", err_with_id)
        }
        else if (response?.payload?.data?.error?.code === "40002") {
          setCartError(error);
          notify("error", error)
        }
        else {
          const err_with_id = `${error}`;
          setCartError(err_with_id);
          notify("error", err_with_id)
        }
      }
      else {
        cb(false)
        notify("error", "Uh-oh! Seller facing a technical issue")
      }
    });
  };

  const onResetSearch = () => {
    setIsSearchActive(false)
    setSearchText("")
    setSelectedSubcategory("All")
    optimizedUserFn()
  }

  const fetchCatalogData = async (payload) => {
    try {
      dispatch(fetchSellersCatalog(payload));
    } catch (error) {
      console.log("HOME : ERROR fetchCatalogData ", error);
    }
  };

  const handleSubcategoryClick = (subcategory) => {
    if (subcategory !== selectedSubcategory) {
      setPage(1)
      setSearchText("")
      setSelectedSubcategory(subcategory);
      setCatalogDataTemp([]);
      setSearchParams({ pid: slug, category: subcategory });
      setIsSearchActive(false)
    }
  };

  const catalogs = (isFromScroll) => {
    if (!catalogues) {
      setCatalogDataTemp([]);
      return;
    }
    let temp = catalogDataTemp;
    // const newData = isFromScroll
    //   ? catalogues.filter(
    //     (item) => !temp.some((existingItem) => existingItem._id === item._id)
    //   )
    //   : catalogues;
    // const tempData = isFromScroll ? temp.concat(newData) : temp;
    const newData = catalogues;
    const tempData = newData;
    setCatalogDataTemp([]);
    const data = tempData.map((data) => {
      const index = cartItems?.findIndex((item) => item?._id === data?._id);
      if (index !== -1) {
        return { ...data, quantity: cartItems[index].quantity };
      } else {
        return { ...data, quantity: 1 };
      }
    });
    setCatalogDataTemp([...data]);
  };

  const updateCartItemQuantity = (itemId, newQuantity, singleCatalogData, addToCart) => {
    const itemIndex = cartItems?.findIndex((item) => item._id === itemId);
    if (newQuantity > parseInt(singleCatalogData?.availableQuantity)) {
      notify(
        "success",
        "Available Quantity is only " + singleCatalogData?.availableQuantity
      );
    } else if (newQuantity > parseInt(singleCatalogData?.maximumQuantity)) {
      notify(
        "success",
        `Maximum quantity available is ${singleCatalogData?.maximumQuantity} for this product`
      );
    } else {
      let updatedCartItems;
      if (itemIndex !== -1) {
        updatedCartItems = cartItems?.map((item, index) =>
          index === itemIndex ? { ...item, quantity: newQuantity } : item
        );
        if (newQuantity === 0) {
          updatedCartItems = updatedCartItems.filter(
            (item) => item._id !== itemId
          );
        }
      } else {
        if (newQuantity !== 0) {
          const newCartItem = {
            _id: singleCatalogData._id,
            productId: singleCatalogData?.productId,
            quantity: newQuantity,
            catalogData: singleCatalogData,
          };
          updatedCartItems = [...cartItems, newCartItem];
        } else {
          updatedCartItems = [...cartItems];
        }
      }
      const cartStorage = JSON.parse(localStorage.getItem("cart")) || [];
      const existingProviderId = cartStorage?.[0]?.catalogData?.providerId;
      if (existingProviderId && updatedCartItems?.some(item => item?.catalogData?.providerId !== existingProviderId)) {
        notify("error", "You can add items from a single store at a time.");
      }
      else {
        // if (localStorage.getItem("landingSource")?.includes("qc") && typeof fbq === 'function') {
        //   fbq('track', 'AddToCart', {
        //     content_name: singleCatalogData.productName,
        //     content_ids: singleCatalogData._id,
        //     value: singleCatalogData.price
        //       ? parseFloat(singleCatalogData.price)
        //       : 0,
        //     currency: 'INR',
        //   });
        // }
        if (newQuantity === 1 && addToCart && !existingProviderId) {
          dispatchOndcSelect(updatedCartItems, singleCatalogData?._id, (status) => {
            if (status) {
              handleAddToCart(
                singleCatalogData?.productName,
                singleCatalogData?._id,
                singleCatalogData?.subCategoryId,
                newQuantity,
                singleCatalogData?.price,
                singleCatalogData?.store?.name
              );
              localStorage.setItem("cart", JSON.stringify(updatedCartItems));
              dispatch(updateCartItem(updatedCartItems));
            }
          });
        }
        else {
          handleAddToCart(
            singleCatalogData?.productName,
            singleCatalogData?._id,
            singleCatalogData?.subCategoryId,
            newQuantity,
            singleCatalogData?.price,
            singleCatalogData?.store?.name
          );
          localStorage.setItem("cart", JSON.stringify(updatedCartItems));
          dispatch(updateCartItem(updatedCartItems));
        }

      }
    }
  };

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setVariant = (variantId, data) => {
    if (variantId) {
      const singleVariant = data?.variants.find((item) => {
        return item?._id === variantId;
      });
      const index = cartItems?.findIndex((item) => item?._id === variantId);
      const tempCatalogs = catalogDataTemp.map((catalog) => {
        if (catalog?._id === data?._id) {
          return {
            ...catalog,
            _id: singleVariant?._id,
            productName: singleVariant?.productName,
            productImages: singleVariant?.productImages,
            weight: singleVariant?.weight,
            weightUnit: singleVariant?.weightUnit,
            price: singleVariant?.price,
            maximumPrice: singleVariant?.maximumPrice,
            quantity: index !== -1 ? cartItems[index].quantity : 1,
          };
        } else {
          return { ...catalog };
        }
      });
      setCatalogDataTemp(tempCatalogs);
    }
  };

  const debounce_search = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 1000);
    };
  };

  const callSearchApi = async (e = "") => {
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    cancelToken = axios.CancelToken.source();
    if (e?.target?.value) {
      setPage(1)
      setSearchParams({ pid: slug, category: "Searched Products", search: e?.target?.value });
      setCatalogDataTemp([]);
      fetchCatalogData({
        userId: slug,
        subCategoryId: selectedSubcategory,
        page: 1,
        sortValue: sort,
        search: e?.target?.value,
      });
    } else {
      setSearchParams({ pid: slug, category: "All" });
      fetchCatalogData({
        userId: slug,
        subCategoryId: selectedSubcategory,
        page: 1,
        sortValue: sort,
      });
    }
  };

  const optimizedUserFn = useCallback(debounce_search(callSearchApi), []);

  let active = 2;
  let items = [];
  for (let number = 1; number <= 5; number++) {
    items.push(
      <Pagination.Item key={number} active={number === active}>
        {number}
      </Pagination.Item>
    );
  }

  const renderPagination = () => {
    const pages = [];
    if (pageCount <= 7) {
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (page > 4) {
        pages.push("...");
      }
      const start = Math.max(2, page - 1);
      const end = Math.min(pageCount - 1, page + 1);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (page < pageCount - 3) {
        pages.push("...");
      }
      pages.push(pageCount);
    }
    return pages.map((p, i) => (
      <li
        key={i}
        className={`pagination-items pageNumber ${p === page ? "active" : ""}`}
      >
        {p === "..." ? (
          <div className="pagination-ellipsis">...</div>
        ) : (
          <div
            onClick={() => fetchNextPage(Number(p))}
            className="pagination-link"
          >
            {p}
          </div>
        )}
      </li>
    ));
  };


  return (
    <>
      <ToastContainer
        autoClose={300}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Header hide={isHeaderHide} title={sellerDetails?.name} />
      <div className="mobile-secondary-header-kl seller-mobile-header">
        <div className="mobile-secondary-header-inner-kl">
          <div
            className="buyer-pin-code-mobile-kl"
          >
            <PageHeader sellerDetails={sellerDetails} isOpen={isOpen} setStoreTiming={setStoreTiming} />
          </div>
        </div>
      </div>
      <div className="category-my-carousel">
        <Swiper
          modules={[Navigation, EffectCreative]}
          className="circular-slider"
          loop={false}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={3}
          effect="creative"
          creativeEffect={{
            perspective: true,
            limitProgress: 3,
            prev: {
              translate: ['-100%', '-35%', -180],
              rotate: [0, 0, -0],
              origin: "top"
            },
            next: {
              translate: ['100%', '-35%', -180],
              rotate: [0, 0, 0],
              origin: "top"
            },
          }}
        >
          {updatedCategories.map((category, index) => (
            <SwiperSlide key={index} >
              <div onClick={() => {
                handleSubcategoryClick(category.title)
              }
              } className={`category-slide ${selectedSubcategory === category.title ? "swiper-active" : ""}`}>
                <div className="category-image-wrapper">
                  <img
                    src={category.imgUrl}
                    alt={category.title}
                    className="category-image"
                  />
                </div>
                <span className="category-name">{category.title}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <Breadcrumb category={searchParams.get("category")} sellerDetails={sellerDetails} />
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <PageHeader sellerDetails={sellerDetails} isOpen={isOpen} setStoreTiming={setStoreTiming} />
          </div>
        </div>
      </div>
      <div className="category-section-kl">
        <div className="category-section-inner-kl">
          <section className="seller-category-slider-kl">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <StoresCategorySlider isHomePage={false} activeCategory={selectedSubcategory} categoriesData={categoriesData} navigate={navigate} handleSubcategoryClick={handleSubcategoryClick} goToTop={goToTop} searchText={searchText} />
                </div>
              </div>
            </div>
          </section>
          <div className="container" ref={catalogsRef}>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <FilterSection selectedSubcategory={selectedSubcategory} catalogueCount={catalogueCount} handleSortChange={handleSortChange} handleSearchInput={handleSearchInput} searchText={searchText} onResetSearch={onResetSearch} />
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {catalogDataTemp?.length === 0 || catalogueStatus === "loading" ? (
                  <div className="stores-list-container">
                    {catalogueStatus === "loading" ? (
                      <Loader />
                    ) : (
                      <EmptyPage
                        image={NoProductFound}
                        EmptySubTitle="No Product Found !"
                        altText=""
                      />
                    )}
                  </div>
                ) :
                  <div className="product-card-container-kl">
                    <>
                      {catalogDataTemp.map((item, index) => (
                        <ProductCard
                          key={index}
                          data={item}
                          catalogDataTemp={catalogDataTemp}
                          navigate={navigate}
                          setVariant={setVariant}
                          updateCartItemQuantity={updateCartItemQuantity}
                          cartItems={cartItems}
                          selectLoading={selectLoading}
                          selectLoadingId={selectLoadingId}
                        />
                      ))}
                    </>
                  </div>}
                {/* <div className="seller-loader">
                  {(catalogueStatus === "loading") && (
                    <Loader />
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {(catalogDataTemp?.length > 0 && catalogueCount > limit) &&
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                <div className="pagination-container">
                  <ul className="pagination-list">
                    <li className="pagination-items">
                      <div onClick={(e) => fetchNextPage(page - 1)} className={`pagination-link prev-arrow ${page > 1 ? "" : "pagination-disabled"}`} >
                        <img src={NxtOneBtn} alt="prev" />
                      </div>
                      <div onClick={(e) => fetchNextPage(page - 2)} className={`pagination-link prev-arrow ${page > 2 ? "" : "pagination-disabled"}`} >
                        <img src={NxtTwoBtn} alt="prev" />
                      </div>
                    </li>
                    {renderPagination()}
                    <li className="pagination-items">
                      <div onClick={(e) => fetchNextPage(page + 1)} className={`pagination-link next ${page >= pageCount ? "pagination-disabled" : ""}`} >
                        <img src={NxtOneBtn} alt="Next" />
                      </div>
                      <div onClick={(e) => fetchNextPage(page + 2)} className={`pagination-link next ${page >= pageCount - 1 ? "pagination-disabled" : ""}`} >
                        <img src={NxtTwoBtn} alt="Next" />
                      </div>
                    </li>
                  </ul>
                  <div className="pagination-showing-items">
                    {`Showing ${start}-${end} of ${catalogueCount} items`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      {
        modalIsOpen && (
          <Login
            isOpenFromCart={false}
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
          ></Login>
        )
      }
      <Modal
        isOpen={addressModal}
        size="lg"
        toggle={() => setAddressModal(false)}
        className="custom-modal-kl"
      >
        <div className="addressmodalBlock">
          <ManageAddress
            onAddressSelected={dispatchOndcSelect}
            setZipcode={setZipcode}
            setAddressModal={setAddressModal}
            setShippingAddress={setShippingAddress}
            zipcode={zipcode}
            isInHeader={false}
          />
        </div>
      </Modal>
      <StoretimingModal
        isOpen={storeTiming}
        toggle={() => setStoreTiming(!storeTiming)}
        storeTimings={sellerDetails}
      />
      <MobileAddCart itemCount={cartItems?.length} />
    </>
  );
};

export default SellerComponent;